import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ShieldCheck } from "@phosphor-icons/react";

// Lets an alumnus / faculty / staff member request editor (manager) access to an
// alumni group. Admins review & approve under Admin → Content → Editor Requests.
export default function RequestEditorButton({ id, name, className }) {
  const [open, setOpen] = useState(false);
  const [role, setRole] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!role.trim()) return toast.error("Tell us your role (e.g. alumnus, faculty, staff)");
    setBusy(true);
    try {
      await api.post(`/groups/${id}/request-editor`, { role_title: role, note });
      toast.success("Request sent — an admin will review it shortly");
      setOpen(false); setRole(""); setNote("");
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Could not send request"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" size="sm" className={`rounded-full gap-1.5 ${className || ""}`} onClick={() => setOpen(true)} data-testid="request-editor-btn">
        <ShieldCheck size={15} weight="duotone" /> Request editor access
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-heading">Request editor access — {name}</DialogTitle>
            <DialogDescription>Tell us your connection so an admin can verify and approve you as an editor.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1.5">
              <Label>Your role / connection</Label>
              <Input value={role} onChange={(e) => setRole(e.target.value)} placeholder="e.g. Alumnus (Class of 2005), Faculty, Alumni Officer" data-testid="request-editor-role" />
            </div>
            <div className="space-y-1.5">
              <Label>Note (optional)</Label>
              <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Anything that helps us verify you (e.g. batch year, a link)" data-testid="request-editor-note" />
            </div>
          </div>
          <DialogFooter><Button onClick={submit} disabled={busy} className="rounded-full" data-testid="request-editor-submit">{busy ? "Sending…" : "Send request"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
